import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Formik } from "formik";
import { extractInstrumentations } from "../../extractors";
import { NotFoundError } from "../../api";
import { SubmitButton, ObjectsTypeahead } from "../Form";
import { ObjectsType } from "../../constants";
import { accessRightsShape, intlShape } from "../../shapes";
import { sortBy } from "../../utils";
import {
  withApi,
  apiShape,
  withNotifier,
  notifierShape,
  withRules,
} from "../../context";
import List from "../List/List";
import InstrumentationItem from "../Instrumentations/InstrumentationItem";
import Hint from "../Hint";

type Props = {
  api: apiShape;
  accessRights?: accessRightsShape;
  intl: intlShape;
  object?: {
    id?: number;
    itemType?: "asset" | "node";
  };
  notifier: notifierShape;
};

export function InstrumentationsAssignList(props: Props) {
  const { intl, api, notifier, accessRights, object } = props;

  const objectTypePlural = `${object?.itemType}s`;
  const objectId = object?.id;

  const [instrumentations, setInstrumentations] = React.useState();
  const parentNode = objectTypePlural.includes("node")
    ? // @ts-expect-error TS(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
      { id: parseInt(objectId, 10) }
    : null;
  const parentAsset = objectTypePlural.includes("asset")
    ? // @ts-expect-error TS(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
      { id: parseInt(objectId, 10) }
    : null;

  React.useEffect(() => {
    const loadData = async () => {
      try {
        const responseInstrumentations = await api.get(
          `/${objectTypePlural}/${objectId}/instrumentations`,
          {
            include: "specifications,status,worst_asset_status",
          },
        );
        const loadedInstrumentations = sortBy(
          extractInstrumentations(responseInstrumentations),
          "tag",
        );
        setInstrumentations(loadedInstrumentations);
      } catch (error) {
        if (!(error instanceof NotFoundError)) {
          notifier.showError(api.translateError(error));
        }
      }
    };
    if (object) {
      loadData();
    }
  }, [objectId]);

  const handleOnInstrumentationRemoved = (instrumentation: $TSFixMe) => {
    setInstrumentations(
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      instrumentations.filter((a: $TSFixMe) => a.id !== instrumentation.id),
    );
  };

  const assignInstrumentation = async (
    values: $TSFixMe,
    { resetForm }: $TSFixMe,
  ) => {
    const payload = { instrumentations: [{ id: values.instrumentation.id }] };
    try {
      await api.post(
        `/${objectTypePlural}/${objectId}/instrumentations`,
        payload,
      );
      setInstrumentations(
        // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
        sortBy(instrumentations.concat([{ ...values.instrumentation }]), "tag"),
      );
      notifier.showSuccess(
        intl.formatMessage({
          id: "instrumentation.actions.assign.notification",
        }),
      );
    } catch (error) {
      if (!(error instanceof NotFoundError)) {
        notifier.showError(api.translateError(error));
      }
    }
    resetForm({ values: {} });
  };

  const renderInstrumentationAssignForm = (formProps: $TSFixMe) => {
    const { handleSubmit, isSubmitting, values } = formProps;
    return (
      <form onSubmit={handleSubmit} noValidate>
        <ObjectsTypeahead
          {...formProps}
          id="instrumentation-typeahead"
          name="instrumentation"
          label={intl.formatMessage({ id: "instrumentation.actions.assign" })}
          placeholder={intl.formatMessage({ id: "label.tag" })}
          objectsToIgnore={instrumentations}
          objectsType={ObjectsType.Instrumentations}
        />
        <div className="btn-group">
          <SubmitButton
            id="assign-instrumentation-button"
            disabled={!values.instrumentation}
            fetching={isSubmitting}
            text={intl.formatMessage({ id: "button.assign" })}
          />
        </div>
      </form>
    );
  };

  return objectId && instrumentations ? (
    <div id="instrumentation-list">
      <h2>
        <FormattedMessage id="instrumentations.header" />
      </h2>
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {accessRights.canPermit ? (
        <Formik
          initialValues={{}}
          id="assign-instrumentation-formik"
          onSubmit={assignInstrumentation}
        >
          {renderInstrumentationAssignForm}
        </Formik>
      ) : null}
      {(instrumentations as $TSFixMe).length > 0 ? (
        <List id="instrumentations_assign_list">
          {(instrumentations as $TSFixMe).map((instrumentation: $TSFixMe) => (
            <InstrumentationItem
              key={instrumentation.id}
              // @ts-expect-error TS(2322) FIXME: Type '{ key: any; instrumentation: any; parentNode... Remove this comment to see the full error message
              instrumentation={instrumentation}
              parentNode={parentNode}
              parentAsset={parentAsset}
              onInstrumentationRemoved={handleOnInstrumentationRemoved}
              showItemMenu
              parentAccessRights={accessRights}
            />
          ))}
        </List>
      ) : (
        <Hint
          id="hint-no-instrumentations-assigned"
          details={intl.formatMessage({
            id: "instrumentation_list.no_instrumentations_assign",
          })}
        />
      )}
    </div>
  ) : null;
}
export default injectIntl(
  // @ts-expect-error TS(2345) FIXME: Argument of type '(props: Props) => Element | null... Remove this comment to see the full error message
  withNotifier(withApi(withRules(InstrumentationsAssignList))),
);
